import {KeycloakUser} from '../../state/user-management.types'

export const getRealname = (user: KeycloakUser) => {
  if ((user.firstName && user.firstName.length > 0) || (user.lastName && user.lastName?.length > 0)) {
    return `${user.firstName} ${user.lastName}`
  }
  return null
}
